import { StyleSheet, Text, View, ImageBackground } from "react-native";
import SafeAreaView from "../components/SafeAreaView";
//import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { MaterialIcons } from "../components/VectorIcons";
import SimplePress from "../components/SimplePress";
import { getSchemeStyle } from "../context/helper";

const OnboardingScreen = ({ navigation }) => {
  const schemeStyles = getSchemeStyle();

  return (
    <SafeAreaView style={[styles.mainContainer,schemeStyles.Background]}>
      <View>
        <Text style={[styles.mainText,schemeStyles.welcomeText]}>Willkommen</Text>
      </View>
      <View style={styles.imageContainer}>
        <ImageBackground
          source={require("../assets/images/sencono-logo.png")}
          style={styles.mainImage}
        />
      </View>
      <SimplePress
        onPress={() => {
          navigation.navigate("Login");
        }}
        style={styles.mainButton}
      >
        <Text style={[styles.mainButtonText,schemeStyles.buttonText]}>Weiter zum Login</Text>
        <MaterialIcons name="arrow-forward-ios" size={24} color={schemeStyles.buttonText.color} />
      </SimplePress>
    </SafeAreaView>
  );
};

export default OnboardingScreen;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 50,
  },
  mainText: {
    fontSize: 30,
    fontWeight: "bold",
    color: "#20315f",
  },
  mainImage: {
    width: 300,
    height: 135,
  },
  mainButton: {
    backgroundColor: "#407daf",
    padding: 20,
    width: "90%",
    borderRadius: 5,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  mainButtonText: {
    fontSize: 18,
    color: "#fff",
    fontFamily: "Roboto-MediumItalic",
  },
  imageContainer: {
    flex: 1,
    justifyContent: "center",
  },
});
